import React, { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import { useCurrentActor } from '../../hooks/useCurrentActor';
import { retrievePath, website } from '../../lib/iris';

import SessionForm, { sessionForms } from './SessionForm';

const SessionPage: FC = () => {
  const [params] = useSearchParams();
  const { actorType } = useCurrentActor();
  const location = useLocation();
  const navigate = useNavigate();

  const form = sessionForms.find(({ path }) => location.pathname.startsWith(path));
  const redirectUrl = params.get('redirect_url') || website;
  const redirectUser = redirectUrl && actorType === 'ConfirmedUser';

  useEffect(() => {
    if (redirectUser) {
      navigate(retrievePath(redirectUrl)!, { replace: true });
    }
  }, [redirectUser]);

  if (redirectUser || !form) {
    return null;
  }

  return <SessionForm form={form} redirectUrl={redirectUrl} />;
};

export default SessionPage;
